import { render } from "./TvmNewVehicle.vue?vue&type=template&id=0cfc118b&scoped=true"
import script from "./TvmNewVehicle.vue?vue&type=script&lang=js"
export * from "./TvmNewVehicle.vue?vue&type=script&lang=js"

import "./TvmNewVehicle.vue?vue&type=style&index=0&id=0cfc118b&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfc118b"],['__file',"src/components/ChatWidget/SlideOutPanel/TvmSlideOutBuyVehicle/TvmNewVehicle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0cfc118b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0cfc118b', __exports__)) {
    api.reload('0cfc118b', __exports__)
  }
  
  module.hot.accept("./TvmNewVehicle.vue?vue&type=template&id=0cfc118b&scoped=true", () => {
    api.rerender('0cfc118b', render)
  })

}


export default __exports__